import {useState} from 'react';
import {initial} from '../../common/domain/RemoteData.model';
import {onboard as _onboard} from '../infrastructure/UserApi';
import {remoteDataWithSetter} from '../../common/utils/remoteDataWithSetter';

/** Acceso de cliente existente: el exito devuelve {id, email} y la pantalla pasa al codigo de verificacion. */
export const useOnboard = () => {
  const [onboardRemoteData, setOnboardRemoteData] = useState(initial(null));

  const onboard = async (userInfo, tenantId) => {
    const dataSetterCallback = () => _onboard(userInfo, tenantId);
    await remoteDataWithSetter(setOnboardRemoteData, dataSetterCallback);
  }

  return { onboardRemoteData, onboard };
}
